import moment, { Moment } from 'moment'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EmptyState } from '../../App/Components/UIElements/EmptyState/EmptyState'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { getUsers } from '../../User/Store/actions'
import DateRangeSelection from '../DateRangeSelection/DateRangeSelection'

import { Client } from './Client/Client'
import { IOccupancyRateReport } from './Client/IOccupancyRateReport'
import { StatisticCard } from './StatisticCards/StatisticCards'
import Style from './style.scss'

export const OccupancyRateReport = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const [from, setFrom] = useState<Moment>(moment().startOf('month'))
  const [to, setTo] = useState<Moment>(moment().endOf('month'))
  const [span, setSpan] = useState<'week' | 'month' | 'year'>('month')
  const [reports, setReports] = useState<IOccupancyRateReport[]>([])

  const [users, isUsersLoading] = useAppSelector(state => {
    return [state.users.list, state.users.loading]
  })

  useEffect(() => {
    if (!users && !isUsersLoading) {
      dispatch(getUsers())
    }
  }, [users, isUsersLoading])

  useEffect(() => {
    Client.getOccupancyReport(from, to).then(newReports => {
      setReports(newReports)
    })
  }, [from, to])

  return (
    <>
      <h1>{t('Occupancy rate report')}</h1>
      <DateRangeSelection
        onSelected={(selectedSpan, selectedFrom, selectedTo) => {
          setSpan(selectedSpan)
          setFrom(selectedFrom)
          setTo(selectedTo)
        }}
        span={span}
        from={from}
        to={to}
        availableSpans={['week', 'month', 'year']}
      />

      <div className={Style.cardsWrapper}>
        {users ? (
          users.map(user => (
            <StatisticCard
              key={user.uuid}
              avatar={user.avatar}
              firstName={user.firstName}
              lastName={user.lastName}
              report={reports.find(report => report.personUuid === user.uuid)}
            />
          ))
        ) : (
          <EmptyState guidance={t('There is no data for this date range.')} />
        )}
      </div>
    </>
  )
}
